<template>
  <div class="trip-list-item mb-30">
    <div class="header-list d-flex flex-wrap text-capitalize text-white">
      <span class="bg-dark font-13 px-15 py-5">Trip ID: {{ trip.id }}</span>
      <span class="bg-primary font-13 px-15 py-5">{{ tripType }}</span>
			<span v-if="tripIsAnEmptyLeg" class="bg-info font-13 px-15 py-5">Empty Leg</span>
    </div>
    <div class="box-shadow p-20">
      <router-link
        :to="{ name: 'TripDetail', params: { trip: trip.id } }"
        class="list-group-item list-group-item-action">
        <div class="row border-bottom mb-20">
          <div class="col-sm-6">
            <data-item label="From">{{ trip.fliesFrom.name}}</data-item>
          </div>
          <div class="col-sm-6">
            <data-item label="To">{{ trip.fliesTo.name}}</data-item>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <data-item v-if="trip.type === 'Proposed'" label="Date range">{{ getFormattedDate(trip.typeFields.rangeFrom) }} to {{ getFormattedDate(trip.typeFields.rangeTo) }}</data-item>
            <data-item v-else label="Date">{{ getFormattedDate(trip.typeFields.departureDate) }}</data-item>
          </div>
          <div class="col-sm-6">
            <data-item v-if="trip.type === 'Proposed'" label="Time of Day">{{ trip.typeFields.timeOfDay }}</data-item>
            <data-item v-else label="Departure Time">{{ getFormattedTime(trip.typeFields.departureTime) }}</data-item>
          </div>
        </div>
        <div v-if="trip.description" class="row">
          <div class="col-sm-12">
            <data-item label="Note">{{ trip.description }}</data-item>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import DataItem from '@/components/Shared/DataItem'
import moment from "moment";

export default {
  components: {
    DataItem
  },
  props: {
    trip: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    tripType() {
      if (this.trip.type == "Planned") {
        return "Planned Trip";
      }
      if (this.trip.type == "Proposed") {
        return "Proposed Trip";
      }
      return "Trip";
    },
    tripIsAnEmptyLeg: function() {
			return this.trip.passengers == 0;
		}
  },
  methods: {
    getFormattedDate(dateTrip) {
      return moment(dateTrip, "YYYY-MM-DD").format("MM-DD-YYYY");
    },
    getFormattedTime(time) {
      return moment(time, "HH:mm:ss").format("HH:mm A");
    },
  }
}
</script>

<style>

</style>